// 本人確認実施中のダイアログ
import React from 'react';
import Popup from './Popup';
interface Props {
  is_guarantor: boolean;
  modal_open: boolean; // ダイヤログ表示
  setModalnOpen: React.Dispatch<React.SetStateAction<boolean>>; // ダイヤログ表示・非表示の切り替え関数
}

const OnlineIdentificationDialog: React.FC<Props> = ({
  is_guarantor,
  modal_open,
  setModalnOpen,
}) => {
  return (
    <Popup
      title="オンライン本人確認の実施"
      text={
        is_guarantor
          ? 'オンライン本人確認の実施が完了しましたら、【借入申込を続ける】から申込の確認を再開して下さい。<br>※ログアウトした場合は、再度マイページにログインして申込の確認を再開して下さい。'
          : 'オンライン本人確認の実施が完了しましたら、【借入申込を続ける】から申込を再開して下さい。<br>※ログアウトした場合は、再度マイページにログインして申込を再開して下さい。'
      }
      first_button={{
        label: '借入申込を続ける',
        variant: 'success',
        class_name: 'right-btn',
        handleClick: () => {
          setModalnOpen(false);
          window.location.reload();
        },
      }}
      toggleClose={() => {
        setModalnOpen(false);
        window.location.reload();
      }}
      toggleShow={modal_open}
    />
  );
};

export default OnlineIdentificationDialog;
